import { ICommand } from '@/utils';
import { MealCountDto, MealCountStatus } from '@/models';
import { IState } from '@/store';
import { Store } from 'vuex';
import { inject } from 'inversify-props';
import { MealCountStatusViewModel } from '@/view-models';

/** Finds statuses for a given list of items */
export class GetCountStatusesCommand implements ICommand<MealCountDto[]> {
  @inject() private store!: Store<IState>;

  run(counts: MealCountDto[]) {
    const countStatuses = this.getStoreStatuses(counts);

    const statuses = counts.map(mc => {
      const countStatus = this.findCountStatus(mc, countStatuses);
      return new MealCountStatusViewModel(mc, countStatus)
        .dashboardModel;
    });

    return statuses;
  }

  findCountStatus(mc: MealCountDto, countStatuses: MealCountStatus[]): MealCountStatus | undefined {
    const result = countStatuses.find(cs =>
      cs.programId === mc.programId
      && cs.siteId === mc.siteId
      && cs.mealTypeId === mc.mealTypeId
      && cs.mealServiceDate === mc.mealServiceDate);

    return result;
  }

  /**
   * get store statuses for given counts
   * @param counts
   */
  getStoreStatuses(counts: MealCountDto[]) {
    const result = this.store.state.meals.mealCountStatuses.filter(mcs => 
      counts.some(c =>
        c.programId === mcs.programId
        && c.siteId === mcs.siteId
        && c.mealTypeId === mcs.mealTypeId
        && c.mealServiceDate === mcs.mealServiceDate)
    );

    return result;
  }
}
